import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowDown, ArrowRight, Download } from 'lucide-react';
import workflow from './workflow.json';

export default function WorkflowDiagram() {
  return <section id="workflow" className="help-workflow" aria-labelledby="workflow-heading">
    <div className="help-section-heading"><div><span className="help-eyebrow">THE COMPLETE PROCEDURE</span><h2 id="workflow-heading">{workflow.title}</h2></div>
      <a className="help-text-link" href="/help-assets/workforce-partners-procedure.png" download><Download size={17} aria-hidden="true" />Download graphic</a>
    </div>
    <p className="help-workflow-intro">{workflow.intro}</p>
    <p className="help-workflow-preparation"><strong>Contractor preparation.</strong> {workflow.preparation}</p>
    <div className="help-workflow-phases">{workflow.phases.map((phase, phaseIndex) => <section key={phase.title} className="help-workflow-phase" aria-labelledby={`workflow-phase-${phaseIndex}`}>
      <h3 id={`workflow-phase-${phaseIndex}`}>{phase.title}</h3>
      <ol start={phase.steps[0].id}>{phase.steps.map(step => <li key={step.id}>
        <div className="help-workflow-node"><div className="help-workflow-owner"><span aria-hidden="true">{String(step.id).padStart(2,'0')}</span>{step.role}</div>
          <h4>{step.title}</h4><p>{step.body}</p>
          {step.branch && <p className="help-workflow-branch">{step.branch}</p>}
          <Link to={`/help/${step.guide}`} className="help-text-link" aria-label={`Instructions: ${step.title}`}>Instructions <ArrowRight size={14} aria-hidden="true" /></Link>
        </div>
        {step.id !== 11 && <ArrowDown className="help-workflow-arrow" size={23} aria-hidden="true" />}
      </li>)}</ol>
      {phaseIndex < 2 && <p className="help-workflow-continue">Continue with phase {phaseIndex + 2} <ArrowRight size={16} aria-hidden="true" /></p>}
    </section>)}</div>
    <p className="help-workflow-timeout"><strong>If the client does not respond.</strong> {workflow.timeout}</p>
  </section>;
}
